import React from "react";
import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

type SvgProps = {
  contents: any;
  width?: number;
  height?: string | number;
  color?: string;
};

type SvgIconProps = IThemeProps<{
  width?: string | number;
  height?: string | number;
  color?: string;
}>;

const SvgIcon = styled.span<SvgIconProps>`
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  width: ${(props) => (props.width ? props.width + "px" : "auto")};
  height: ${(props) => (props.height ? props.height + "px" : "auto")};
  line-height: ${(props) => (props.height ? props.height + "px" : "inherit")};

  svg {
    display: inline-block;
    width: ${(props) => (props.width ? props.width + "px" : "auto")};
    height: ${(props) => (props.height ? props.height + "px" : "auto")};
    ${(props) => (props.color ? "fill:" + props.color + ";" : "")}
  }
`;

const Svg: React.FC<SvgProps> = ({ contents, width, height, color }) => (
  <SvgIcon
    width={width}
    height={height}
    color={color}
    dangerouslySetInnerHTML={{ __html: contents }}
  />
);

export default React.memo(Svg);
